import React from "react";
import { GoogleOutlined,FacebookOutlined } from "@ant-design/icons";
import "firebase/app";

import{auth} from '../firebase';
import firebase from "firebase/app";

const Login=()=>{
    return(
        <div id="login-page">
            <div id="login-card">
                <h2>Welcome To My Chat app Marco People!</h2>
                <div className="login-button google" onClick={()=>auth.signInWithRedirect(new firebase.auth.GoogleAuthProvider())}>
                    <GoogleOutlined/> Signin in with google
                </div>
                <br /><br />
                
            </div>
        </div>
    );
}
export default Login;